// Module
var code = "<internal-api-keys></internal-api-keys>\n";
// Exports
module.exports = code;